import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=489af590&scoped=true&"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=489af590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489af590",
  null
  
)

component.options.__file = "Navbar.vue"
export default component.exports